CourseController.$inject = ['$rootScope', 'CourseService', '$stateParams', 'AppService', '$uibModal', '$state', '$transitions']

export default function CourseController($rootScope, CourseService, $stateParams, AppService, $uibModal, $state, $transitions) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var copy
  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      CourseService.getCourse(profileId, $stateParams.slug).then(res => {
        vm.course = res.data
        copy = angular.copy(vm.course)
      })
    }
  })

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.course.isPromoted = !vm.course.isPromoted
  }
  vm.setPublished = function() {
    vm.course.isPublished = !vm.course.isPublished
  }
  vm.toggleAddLesson = function() {
    vm.addLesson = !vm.addLesson
  }
  vm.delete = function() {
    vm.confirmDelete = true
  }
  vm.doDelete = function() {
    vm.hideAlert('confirmDelete')
    CourseService.deleteCourse(vm.course).then(() => $state.go('shell.courses'))
  }
  vm.tabs = [0, 1, 2, 3]
  vm.activeTab = $stateParams.activeTab ? $stateParams.activeTab : 0
  vm.setActiveTab = function(index) {
    vm.activeTab = index
  }
  vm.hideAlert = function(alert) {
    vm[alert] = false
  }
  $transitions.onBefore({}, () => {
    if (!angular.equals(vm.course, copy)) return CourseService.putCourse(vm.course)
  }, {invokeLimit: 1})
}